<template>
  <div>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Booking number</h3></v-col>
      <v-col><h3>{{ booking.orderNumber.number }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text"> Customer </h3>
      </v-col>
      <v-col>
        <h3> {{ booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName +' '+ booking.customer.lastName }} </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2 class="primary--text"> No action required </h2>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'DriverDropped',
  props: { 
    booking: Object
  }
}
</script>

<style scoped>

</style>